import menuItems from "./menuItems.json";
import { NavLink } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { LangContext, CanvasContext } from "../App";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

export default function Menu({ isOpen, changeData }) {
  const [active, setActive] = useState(true);
  const lang = useContext(LangContext);
  const [chooseLang, setChooseLang] = useState("PL");
  const canvas = useContext(CanvasContext);
  function clickedHandler() {
    const newLang = lang === "pl" ? "en" : "pl";
    changeData(newLang);
    setChooseLang(newLang === "pl" ? "EN" : "PL");
  }

  useEffect(() => {
    if (lang === "pl") {
      setChooseLang("EN");
    }
    if (lang === "en") {
      setChooseLang("PL");
    }
  }, [lang]);

  function handleActive(val) {
    setActive(val);
  }

  return (
    <CanvasContext.Provider value={canvas}>
      <ul className={`main-nav ${isOpen ? "active" : ""}`}>
        {menuItems.map((item, index) => {
          return (
            <li key={item.id}>
              <NavLink to={item.name}>
                <p
                  onClick={() => handleActive(item)}
                  className={`nav-item-lato ${active === item ? "active" : ""}`}
                >
                  {index === 0 ? (
                    <HomeOutlinedIcon fontSize="large" />
                  ) : (
                    <FormattedMessage id={item.name} />
                  )}
                </p>
              </NavLink>
            </li>
          );
        })}

        <li>
          <p className="nav-item-lato" onClick={clickedHandler}>
            {chooseLang}
          </p>
        </li>
      </ul>
    </CanvasContext.Provider>
  );
}
